import { useEffect, useRef } from "react"

import { pingSessionActivity } from "../services/session-activity"

const INTERACTION_EVENTS = [
  "pointerdown",
  "keydown",
  "wheel",
  "touchstart"
] as const

export const PING_INTERVAL_MS = 5 * 60 * 1000
export const CHECK_INTERVAL_MS = 30 * 1000

export const useSessionActivityPing = (isAuthenticated: boolean) => {
  const lastInteractionAtRef = useRef(0)
  const lastPingAtRef = useRef(0)

  useEffect(() => {
    if (!isAuthenticated) return

    const markInteraction = () => {
      lastInteractionAtRef.current = Date.now()
    }

    INTERACTION_EVENTS.forEach((event) =>
      window.addEventListener(event, markInteraction, { passive: true })
    )

    const timer = window.setInterval(() => {
      const interactedSinceLastPing =
        lastInteractionAtRef.current > lastPingAtRef.current
      const intervalElapsed =
        Date.now() - lastPingAtRef.current >= PING_INTERVAL_MS

      if (interactedSinceLastPing && intervalElapsed) {
        lastPingAtRef.current = Date.now()
        void pingSessionActivity()
      }
    }, CHECK_INTERVAL_MS)

    return () => {
      INTERACTION_EVENTS.forEach((event) =>
        window.removeEventListener(event, markInteraction)
      )
      window.clearInterval(timer)
    }
  }, [isAuthenticated])
}
